/* Generated by scripts/generate.ts from src/locales. Do not edit by hand. */
import type { NamespaceSchema } from "../catalogue";

export interface ActivityCopy {
  section: {
    actionRequired: string;
    scheduled: string;
    history: string;
  };
  bankAccount: {
    title: string;
    subtitle: string;
    action: string;
  };
  paymentDue: {
    title: string;
    subtitle: string;
    action: string;
  };
  earningsDecision: {
    title: string;
    subtitle: string;
    action: string;
  };
  earningsDestination: {
    title: string;
    subtitle: string;
    action: string;
  };
  lossEvent: {
    subtitle: string;
    action: string;
  };
  pendingWithdrawal: {
    title: string;
    subtitle: (args: { requested: string | number }) => string;
    subtitleNoDate: string;
  };
  pendingLiquidation: {
    title: string;
    subtitle: (args: { requested: string | number }) => string;
    subtitleNoDate: string;
  };
  movingOut: {
    title: (args: { destinationDealName: string | number }) => string;
    titleNoDestination: string;
    subtitle: (args: { started: string | number }) => string;
    subtitleNoDate: string;
  };
  movingIn: {
    title: (args: { sourceDealName: string | number }) => string;
    subtitle: (args: { started: string | number }) => string;
    subtitleNoDate: string;
    converting: (args: { amount: string | number; currency: string | number }) => string;
  };
  processingPayment: {
    title: string;
    subtitle: string;
  };
  deposit: {
    topUpTitle: string;
    awaitingDeployment: string;
  };
  invested: {
    title: string;
    startsEarning: (args: { rate: string | number; date: string | number }) => string;
    earningSince: (args: { rate: string | number; date: string | number }) => string;
    earning: (args: { rate: string | number }) => string;
    plain: string;
  };
  upcomingEarnings: {
    title: string;
    subtitle: string;
  };
  legacyTitle: {
    earningsReceived: string;
    ifIsaTransferred: string;
    investmentFinalised: string;
    paymentCancelled: string;
    paymentProcessing: string;
    paymentReceived: string;
    reallocationCancelled: string;
    reallocationConfirmed: string;
    reallocationReceived: string;
    reallocationStarted: string;
    upcomingEarnings: string;
    withdrawalCancelled: string;
    withdrawalInitiated: string;
    withdrawalPaidOut: string;
  };
  transition: {
    stepUpOut: (args: { tense: string | number; deal: string | number }) => string;
    stepUpIn: (args: { tense: string | number; deal: string | number }) => string;
    stepDownOut: (args: { tense: string | number; deal: string | number }) => string;
    stepDownIn: (args: { tense: string | number; deal: string | number }) => string;
    liquidation: (args: { tense: string | number }) => string;
    noticeTitle: string;
    pendingImmediate: (args: { landsOn: string | number }) => string;
    pendingNotice: string;
    inNoticeUntil: (args: { landsOn: string | number }) => string;
    inNotice: string;
    settledOn: (args: { landsOn: string | number }) => string;
    settled: string;
    noticeEndedOn: (args: { landsOn: string | number }) => string;
    noticeEnded: string;
    rateMove: (args: { from: string | number; to: string | number }) => string;
    rateInNotice: (args: { notice: string | number }) => string;
    rateExit: (args: { notice: string | number }) => string;
  };
  reallocation: {
    outTitle: (args: { deal: string | number }) => string;
    inTitle: (args: { deal: string | number }) => string;
    completedOutTitle: string;
    completedInTitle: string;
    pending: (args: { date: string | number }) => string;
    outInNotice: (args: { rate: string | number; date: string | number }) => string;
    outInNoticeNoDate: (args: { rate: string | number }) => string;
    inInNotice: (args: { deal: string | number; rate: string | number }) => string;
    inInNoticeNoRate: (args: { deal: string | number }) => string;
    outWithTeam: string;
    inWithTeam: (args: { deal: string | number }) => string;
    completedOut: (args: { amount: string | number; deal: string | number }) => string;
    completedIn: (args: { deal: string | number }) => string;
    cancelled: string;
    outFailedTitle: (args: { deal: string | number }) => string;
    inFailedTitle: (args: { deal: string | number }) => string;
    failed: string;
    noticeStartedTitle: string;
    noticeServing: (args: { amount: string | number }) => string;
    noticeServed: (args: { amount: string | number; rate: string | number }) => string;
  };
  isaSwitch: {
    intoTitle: string;
    outTitle: string;
    intoCancelledTitle: string;
    outCancelledTitle: string;
    failedTitle: string;
    pending: (args: { date: string | number }) => string;
    cancelled: string;
    failedAllowance: string;
    failedAccount: string;
  };
  distributionRow: {
    underNotice: string;
    reLocked: string;
    topUp: (args: { date: string | number }) => string;
    opening: string;
    footnote: string;
    decision: (args: { decision: string | number }) => string;
    unsettledWithdrawal: (args: { status: string | number }) => string;
    sublabelRate: (args: { principal: string | number; rate: string | number }) => string;
    sublabelExitRate: (args: { rate: string | number }) => string;
    sublabelPartQuarter: (args: { started: string | number }) => string;
    sublabelQuarters: (args: { quarters: number }) => string;
  };
  distribution: {
    statusLabel: (args: { status: string | number }) => string;
    title: (args: { month: string | number }) => string;
    titleNoDate: string;
  };
  earningsCalendar: {
    withdrawalRequested: string;
    withdrawalRequestedBody: string;
    withdrawalCancelled: string;
    withdrawalCancelledBody: string;
    handling: (args: { decision: string | number }) => string;
    explanation: (args: { decision: string | number }) => string;
    unknownDeal: string;
  };
  legacyTimeline: {
    ifIsaTransferFrom: (args: { transferManagerName: string | number }) => string;
    ifIsaTransferReceived: string;
    paymentReceivedName: string;
    paymentReceivedBody: string;
    paymentReceivedStatement: string;
    paymentProcessingBody: string;
    paymentProcessingName: string;
    paymentProcessingStatement: string;
    paymentCancelledName: string;
    paymentCancelledStatement: string;
    earningsCancelledWithdrawal: string;
    earningsToBank: string;
    earningsReinvested: string;
    earningsReceivedFallback: string;
    earningsReceivedName: string;
    upcomingEarningsBody: string;
    upcomingEarningsName: string;
    upcomingEarningsStatement: string;
    withdrawalInitiatedName: string;
    withdrawalInitiatedStatement: string;
    withdrawalCancelledName: string;
    withdrawalCancelledStatement: string;
    withdrawalPaidTo: (args: { accountName: string | number }) => string;
    withdrawalPaidOut: string;
    withdrawalPaidOutName: string;
    reallocationReservedTo: (args: { destinationDealName: string | number }) => string;
    reallocationReserved: string;
    reallocationStartedName: string;
    reallocationCancelledTo: (args: { destinationDealName: string | number }) => string;
    reallocationCancelled: string;
  };
  inMotion: {
    withdrawingLabel: string;
    withdrawingDescription: string;
    movingLabel: string;
    movingDescription: string;
    reallocatingDescription: string;
    deployingLabel: string;
    deployingDescription: string;
  };
}

export const activitySchema: NamespaceSchema = {
  namespace: "activity",
  keys: {
    "section.actionRequired": [],
    "section.scheduled": [],
    "section.history": [],
    "bankAccount.title": [],
    "bankAccount.subtitle": [],
    "bankAccount.action": [],
    "paymentDue.title": [],
    "paymentDue.subtitle": [],
    "paymentDue.action": [],
    "earningsDecision.title": [],
    "earningsDecision.subtitle": [],
    "earningsDecision.action": [],
    "earningsDestination.title": [],
    "earningsDestination.subtitle": [],
    "earningsDestination.action": [],
    "lossEvent.subtitle": [],
    "lossEvent.action": [],
    "pendingWithdrawal.title": [],
    "pendingWithdrawal.subtitle": ["requested"],
    "pendingWithdrawal.subtitleNoDate": [],
    "pendingLiquidation.title": [],
    "pendingLiquidation.subtitle": ["requested"],
    "pendingLiquidation.subtitleNoDate": [],
    "movingOut.title": ["destinationDealName"],
    "movingOut.titleNoDestination": [],
    "movingOut.subtitle": ["started"],
    "movingOut.subtitleNoDate": [],
    "movingIn.title": ["sourceDealName"],
    "movingIn.subtitle": ["started"],
    "movingIn.subtitleNoDate": [],
    "movingIn.converting": ["amount", "currency"],
    "processingPayment.title": [],
    "processingPayment.subtitle": [],
    "deposit.topUpTitle": [],
    "deposit.awaitingDeployment": [],
    "invested.title": [],
    "invested.startsEarning": ["rate", "date"],
    "invested.earningSince": ["rate", "date"],
    "invested.earning": ["rate"],
    "invested.plain": [],
    "upcomingEarnings.title": [],
    "upcomingEarnings.subtitle": [],
    "legacyTitle.earningsReceived": [],
    "legacyTitle.ifIsaTransferred": [],
    "legacyTitle.investmentFinalised": [],
    "legacyTitle.paymentCancelled": [],
    "legacyTitle.paymentProcessing": [],
    "legacyTitle.paymentReceived": [],
    "legacyTitle.reallocationCancelled": [],
    "legacyTitle.reallocationConfirmed": [],
    "legacyTitle.reallocationReceived": [],
    "legacyTitle.reallocationStarted": [],
    "legacyTitle.upcomingEarnings": [],
    "legacyTitle.withdrawalCancelled": [],
    "legacyTitle.withdrawalInitiated": [],
    "legacyTitle.withdrawalPaidOut": [],
    "transition.stepUpOut": ["tense", "deal"],
    "transition.stepUpIn": ["tense", "deal"],
    "transition.stepDownOut": ["tense", "deal"],
    "transition.stepDownIn": ["tense", "deal"],
    "transition.liquidation": ["tense"],
    "transition.noticeTitle": [],
    "transition.pendingImmediate": ["landsOn"],
    "transition.pendingNotice": [],
    "transition.inNoticeUntil": ["landsOn"],
    "transition.inNotice": [],
    "transition.settledOn": ["landsOn"],
    "transition.settled": [],
    "transition.noticeEndedOn": ["landsOn"],
    "transition.noticeEnded": [],
    "transition.rateMove": ["from", "to"],
    "transition.rateInNotice": ["notice"],
    "transition.rateExit": ["notice"],
    "reallocation.outTitle": ["deal"],
    "reallocation.inTitle": ["deal"],
    "reallocation.completedOutTitle": [],
    "reallocation.completedInTitle": [],
    "reallocation.pending": ["date"],
    "reallocation.outInNotice": ["rate", "date"],
    "reallocation.outInNoticeNoDate": ["rate"],
    "reallocation.inInNotice": ["deal", "rate"],
    "reallocation.inInNoticeNoRate": ["deal"],
    "reallocation.outWithTeam": [],
    "reallocation.inWithTeam": ["deal"],
    "reallocation.completedOut": ["amount", "deal"],
    "reallocation.completedIn": ["deal"],
    "reallocation.cancelled": [],
    "reallocation.outFailedTitle": ["deal"],
    "reallocation.inFailedTitle": ["deal"],
    "reallocation.failed": [],
    "reallocation.noticeStartedTitle": [],
    "reallocation.noticeServing": ["amount"],
    "reallocation.noticeServed": ["amount", "rate"],
    "isaSwitch.intoTitle": [],
    "isaSwitch.outTitle": [],
    "isaSwitch.intoCancelledTitle": [],
    "isaSwitch.outCancelledTitle": [],
    "isaSwitch.failedTitle": [],
    "isaSwitch.pending": ["date"],
    "isaSwitch.cancelled": [],
    "isaSwitch.failedAllowance": [],
    "isaSwitch.failedAccount": [],
    "distributionRow.underNotice": [],
    "distributionRow.reLocked": [],
    "distributionRow.topUp": ["date"],
    "distributionRow.opening": [],
    "distributionRow.footnote": [],
    "distributionRow.decision": ["decision"],
    "distributionRow.unsettledWithdrawal": ["status"],
    "distribution.statusLabel": ["status"],
    "distribution.title": ["month"],
    "distribution.titleNoDate": [],
    "earningsCalendar.withdrawalRequested": [],
    "earningsCalendar.withdrawalRequestedBody": [],
    "earningsCalendar.withdrawalCancelled": [],
    "earningsCalendar.withdrawalCancelledBody": [],
    "earningsCalendar.handling": ["decision"],
    "earningsCalendar.explanation": ["decision"],
    "earningsCalendar.unknownDeal": [],
    "legacyTimeline.ifIsaTransferFrom": ["transferManagerName"],
    "legacyTimeline.ifIsaTransferReceived": [],
    "legacyTimeline.paymentReceivedName": [],
    "legacyTimeline.paymentReceivedBody": [],
    "legacyTimeline.paymentReceivedStatement": [],
    "legacyTimeline.paymentProcessingBody": [],
    "legacyTimeline.paymentProcessingName": [],
    "legacyTimeline.paymentProcessingStatement": [],
    "legacyTimeline.paymentCancelledName": [],
    "legacyTimeline.paymentCancelledStatement": [],
    "legacyTimeline.earningsCancelledWithdrawal": [],
    "legacyTimeline.earningsToBank": [],
    "legacyTimeline.earningsReinvested": [],
    "legacyTimeline.earningsReceivedFallback": [],
    "legacyTimeline.earningsReceivedName": [],
    "legacyTimeline.upcomingEarningsBody": [],
    "legacyTimeline.upcomingEarningsName": [],
    "legacyTimeline.upcomingEarningsStatement": [],
    "legacyTimeline.withdrawalInitiatedName": [],
    "legacyTimeline.withdrawalInitiatedStatement": [],
    "legacyTimeline.withdrawalCancelledName": [],
    "legacyTimeline.withdrawalCancelledStatement": [],
    "legacyTimeline.withdrawalPaidTo": ["accountName"],
    "legacyTimeline.withdrawalPaidOut": [],
    "legacyTimeline.withdrawalPaidOutName": [],
    "legacyTimeline.reallocationReservedTo": ["destinationDealName"],
    "legacyTimeline.reallocationReserved": [],
    "legacyTimeline.reallocationStartedName": [],
    "legacyTimeline.reallocationCancelledTo": ["destinationDealName"],
    "legacyTimeline.reallocationCancelled": [],
    "inMotion.withdrawingLabel": [],
    "inMotion.withdrawingDescription": [],
    "inMotion.movingLabel": [],
    "inMotion.movingDescription": [],
    "inMotion.reallocatingDescription": [],
    "inMotion.deployingLabel": [],
    "inMotion.deployingDescription": [],
    "distributionRow.sublabelRate": ["principal", "rate"],
    "distributionRow.sublabelExitRate": ["rate"],
    "distributionRow.sublabelPartQuarter": ["started"],
    "distributionRow.sublabelQuarters": ["quarters"],
  },
};
